import * as THREE from 'three'
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import Stats from 'stats.js'

export default class Renderer {
    constructor(world) {
        this.world = world
        this.debug = this.world.debug
        this.canvas = this.world.canvas
        this.sizes = this.world.sizes
        this.camera = this.world.camera.perspectiveCamera
        this.time = this.world.time
        this.environment = this.world.environment

        this.setInstance()
    }

    setInstance() {
        //Renderer
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            powerPreference: 'high-performance',
            antialias: true
        })

        //Renderer settings
        this.instance.setClearColor(0x1e2b3e)
        this.instance.physicallyCorrectLights = true
        this.instance.outputEncoding = THREE.sRGBEncoding
        this.instance.gamma = 2.2;
        this.instance.shadowMap.enabled = true
        this.instance.shadowMap.autoUpdate = true
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)

        //Render info
        // console.log(this.instance.info)

        // init CSS2DRenderer
        this.labelRenderer = new CSS2DRenderer();
        this.labelRenderer.setSize( this.sizes.width, this.sizes.height );
        this.labelRenderer.domElement.style.position = 'absolute';
        this.labelRenderer.domElement.style.top = '0';
        this.labelRenderer.domElement.style.pointerEvents = 'none';
        document.body.appendChild( this.labelRenderer.domElement );


        this.stats = new Stats()
            this.stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom

        //////////////////////////////////////////////
        //FPS simulation
        if (this.debug.active) {
            document.body.appendChild(this.stats.dom)
            this.renderFolder = this.debug.ui.addFolder('Dynamic quality')
        
            this.fps_parameters = {
                value: 120,
            }

            this.renderFolder.add(this.fps_parameters, 'value').name('FPS simulation')
                .min(0)
                .max(120)
                .step(1)          
                .onChange(() =>
            {
                this.fps = this.fps_parameters.value
            })
        }
        //////////////////////////////////////////////


        this.lastTime = performance.now()
        this.frameCount = 0
        this.fpsMeasureCount = 0
        this.redoFPS = false

        this.high = true
        this.medium = false
        this.low = false
    }

    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
        this.instance.outputEncoding = THREE.sRGBEncoding
        this.labelRenderer.setSize(this.sizes.width, this.sizes.height)

        this.redoFPS = true
        if(this.redoFPS) {
            this.fps = 60
            this.deltaTime = 0;
            this.fpsMeasureCount = 0
        }
    }

    update()
    {
        this.stats.begin()
        //
            this.instance.render(this.world.scene, this.camera)
            this.labelRenderer.render(this.world.scene, this.camera)
        //
        this.stats.end()

        //Measuring FPS count
        this.currentTime = performance.now();
        this.deltaTime = this.currentTime - this.lastTime;

        this.frameCount++
        if (this.deltaTime >= 2000 && this.fpsMeasureCount <= 2) {

            if (this.fpsMeasureCount === 2){
                this.fps = Math.round(this.frameCount / (this.deltaTime / 1000))
                // console.log(this.fps);
            }

            this.frameCount = 0
            this.lastTime = this.currentTime
            this.fpsMeasureCount++
        }

        if (this.fps > 55) {
            this.high = true
            this.medium = false
            this.low = false
        } else if (this.fps <= 55 && this.fps >= 15 ){
            this.high = false
            this.medium = true
            this.low = false
        } else if (this.fps < 15 ){
            this.high = false
            this.medium = false
            this.low = true
            
        } 
    }
}




